// Chinese translations (Simplified)
export const zh = {
  brandName: "VAROTRADES Inc",
  login: "登录",
  register: "注册",
  logout: "退出",
  dashboard: "仪表板",
  settings: "设置",
  adminPanel: "管理面板",
  search: "搜索",
  viewAll: "查看全部",
  learnMore: "了解更多",
  getStarted: "开始使用",
  downloadApp: "下载应用",
  
  nav: {
    trade: "交易",
    markets: "市场",
    earn: "赚取",
    learn: "学习",
    more: "更多",
    spotTrading: "现货交易",
    spotTradingDesc: "买卖2000+种加密货币",
    futures: "合约交易",
    futuresDesc: "最高125倍杠杆",
    marginTrading: "杠杆交易",
    marginTradingDesc: "放大您的交易能力",
    copyTrading: "跟单交易",
    copyTradingDesc: "自动跟随顶级交易员",
    tradingBots: "交易机器人",
    tradingBotsDesc: "24/7自动化策略",
    p2pTrading: "P2P交易",
    p2pTradingDesc: "直接与他人交易",
    marketOverview: "市场概览",
    marketOverviewDesc: "所有市场和价格",
    cryptocurrencies: "加密货币",
    cryptocurrenciesDesc: "BTC, ETH及2000+种",
    newListings: "新币上线",
    newListingsDesc: "最新代币添加",
    topGainers: "涨幅榜",
    topGainersDesc: "今日最佳表现",
    simpleEarn: "简单赚币",
    simpleEarnDesc: "灵活储蓄高达12% APY",
    staking: "质押",
    stakingDesc: "锁定并获得奖励",
    launchpool: "新币挖矿",
    launchpoolDesc: "挖掘新代币",
    hodlerAirdrops: "持币空投",
    hodlerAirdropsDesc: "持有者奖励",
    cryptoAcademy: "加密学院",
    cryptoAcademyDesc: "适合所有级别的课程",
    videoTutorials: "视频教程",
    videoTutorialsDesc: "逐步指南",
    articlesGuides: "文章与指南",
    articlesGuidesDesc: "深度知识",
    helpCenter: "帮助中心",
    helpCenterDesc: "常见问题和支持",
    aboutUs: "关于我们",
    aboutUsDesc: "我们的故事和使命",
    security: "安全",
    securityDesc: "我们如何保护您",
    proofOfReserves: "储备金证明",
    proofOfReservesDesc: "100%透明",
    careers: "招聘",
    careersDesc: "加入我们的团队",
  },
  
  hero: {
    title1: "您通往",
    title2: "加密货币的大门",
    subtitle: "受到超过",
    traders: "4900万",
    tradersText: "交易者的信赖",
    continueWith: "或继续使用",
  },
  
  stats: {
    volume24h: "24小时交易量",
    cryptocurrencies: "加密货币",
    simpleEarnApy: "简单赚币APY",
    reserveRatio: "储备金比率",
  },
  
  products: {
    title: "随时随地交易",
    subtitle: "适合所有交易策略的多样化产品",
    spotTrading: "现货交易",
    spotDesc: "2000+交易对",
    futures: "合约交易",
    futuresDesc: "最高125倍杠杆",
    copyTrading: "跟单交易",
    copyDesc: "跟随专家",
    tradingBots: "交易机器人",
    botsDesc: "24/7自动化",
    simpleEarn: "简单赚币",
    earnDesc: "灵活收益",
    launchpool: "新币挖矿",
    launchDesc: "新代币",
    popular: "热门",
    hot: "火爆",
    easy: "简单",
    smart: "智能",
    earn: "赚取",
    exclusive: "独家",
  },
  
  howToStart: {
    title: "如何开始",
    step1Title: "创建账户",
    step1Desc: "注册并获得专属欢迎奖励",
    step2Title: "快速购买",
    step2Desc: "简单步骤购买加密货币",
    step3Title: "开始交易",
    step3Desc: "交易、跟单并获得更多收益",
    welcomeBonus: "欢迎奖励",
    forNewUsers: "新用户专享",
  },
  
  security: {
    title: "我们保护每一笔交易",
    subtitle: "多层安全保护您的资产",
    advancedSecurity: "高级安全",
    advancedSecurityDesc: "经审计的智能合约和链上监控防止漏洞",
    proofOfReserves: "储备金证明",
    proofOfReservesDesc: "首个提供100%储备金及透明审计的平台",
    secureStorage: "安全存储",
    secureStorageDesc: "战略性冷钱包存储保护您的资产",
  },
  
  cta: {
    title: "今天开始您的旅程",
    subtitle: "加入全球数百万交易者，享受安全可靠的交易体验",
    createAccount: "创建免费账户",
    exploreMarkets: "探索市场",
  },
  
  footer: {
    products: "产品",
    services: "服务",
    support: "支持",
    company: "公司",
    legal: "法律",
    description: "数百万用户信赖的全球交易平台。安全透明地交易。",
    downloadApp: "下载应用",
    sslEncrypted: "SSL加密",
    reserves: "储备金",
    securityAudited: "安全审计",
    allRightsReserved: "保留所有权利",
    riskWarning: "风险警告：加密货币交易涉及高风险。交易前请确保您了解风险。",
    termsOfService: "服务条款",
    privacyPolicy: "隐私政策",
    riskDisclosure: "风险披露",
    amlPolicy: "反洗钱政策",
    helpCenter: "帮助中心",
    faq: "常见问题",
    fees: "费用",
    apiDocs: "API文档",
    submitRequest: "提交请求",
    aboutVAROTRADES: "关于VAROTRADES",
    news: "新闻",
    partnerships: "合作伙伴",
    buyCrypto: "购买加密货币",
  },
  
  promo: {
    signUpNow: "立即注册获得高达",
    upTo: "",
    inRewards: "奖励",
  },
  
  priceCard: {
    hot: "热门",
    new: "新币",
    gainers: "涨幅榜",
  },
  
  partners: {
    officialPartner: "官方合作伙伴：",
  },
  
  loginPage: {
    title: "登录",
    welcome: "欢迎回到VAROTRADES",
    email: "电子邮箱",
    password: "密码",
    forgotPassword: "忘记密码？",
    loggingIn: "登录中...",
    continueWith: "或继续使用",
    noAccount: "没有账户？",
    registerNow: "立即注册",
    demoAccount: "演示账户：",
    invalidCredentials: "邮箱或密码无效",
    twoFactorTitle: "双重认证",
    twoFactorDesc: "输入您的身份验证器应用中的代码",
    verify: "验证",
    goBack: "返回",
    invalidCode: "验证码无效",
  },
  
  registerPage: {
    title: "创建账户",
    subtitle: "立即加入VAROTRADES",
    welcomeBonus: "$100欢迎奖励",
    bonusDesc: "立即注册领取奖励",
    firstName: "名",
    lastName: "姓",
    confirmPassword: "确认密码",
    agreeToTerms: "我同意",
    termsOfService: "服务条款",
    and: "和",
    privacyPolicy: "隐私政策",
    creatingAccount: "正在创建账户...",
    createAccount: "创建账户",
    registerWith: "或注册使用",
    haveAccount: "已有账户？",
    mustAgree: "您必须同意服务条款",
    passwordMismatch: "密码不匹配",
    passwordLength: "密码必须至少6个字符",
    accountFailed: "创建账户失败",
  },
  
  marketsPage: {
    title: "市场",
    subtitle: "跟踪价格、市值和交易量",
    totalMarketCap: "总市值",
    volume24h: "24小时交易量",
    btcDominance: "BTC主导地位",
    activeCryptos: "活跃加密货币",
    all: "全部",
    hot: "热门",
    newListings: "新上线",
    topGainers: "涨幅榜",
    topLosers: "跌幅榜",
    searchCoins: "搜索币种...",
    filter: "筛选",
    name: "名称",
    price: "价格",
    change24h: "24小时涨跌",
    volume: "24小时交易量",
    action: "操作",
    trade: "交易",
    loadMore: "加载更多",
    readyToTrade: "准备好开始交易了吗？",
    joinMillions: "加入数百万交易者，今天开始您的加密之旅",
  },
  
  learnPage: {
    title: "学习",
    titleHighlight: "加密",
    titleEnd: "交易",
    subtitle: "免费课程、教程和指南，掌握加密货币交易",
    searchPlaceholder: "搜索课程、文章、视频...",
    all: "全部",
    beginner: "初学者",
    trading: "交易",
    security: "安全",
    defi: "DeFi",
    featuredCourses: "精选课程",
    viewAll: "查看全部",
    videoTutorials: "视频教程",
    articlesGuides: "文章与指南",
    faq: "常见问题",
    faqSubtitle: "常见问题快速解答",
    viewAllFaqs: "查看所有常见问题",
    readyToPractice: "准备好实践所学了吗？",
    startTradingConfidence: "用所学知识自信地开始交易",
    startTradingNow: "立即开始交易",
    lessons: "课时",
    views: "观看次数",
    minRead: "分钟阅读",
  },
  
  companyPage: {
    title: "关于",
    titleHighlight: "VAROTRADES",
    subtitle: "通过让加密货币变得易于获取、安全和简单，构建金融的未来。",
    registeredUsers: "注册用户",
    countriesServed: "服务国家",
    dailyVolume: "日交易量",
    cryptocurrencies: "加密货币",
    ourStory: "我们的故事",
    ourStoryP1: "VAROTRADES成立于2017年，使命简单：让每个人都能进行加密货币交易。",
    ourStoryP2: "从一个小型加密爱好者团队发展成为服务数百万用户的全球平台。",
    ourStoryP3: "如今，我们自豪地成为全球领先的加密货币交易所之一。",
    ourValues: "我们的价值观",
    ourValuesSubtitle: "指导我们一切行动的原则",
    securityFirst: "安全第一",
    securityFirstDesc: "我们优先保护用户资产的安全。",
    userCentric: "以用户为中心",
    userCentricDesc: "每个决定都以用户利益为导向。",
    innovation: "创新",
    innovationDesc: "我们不断突破界限，提供尖端交易解决方案。",
    globalAccess: "全球访问",
    globalAccessDesc: "让每个人、在任何地方都能使用加密货币。",
    securityTrust: "安全与信任",
    securityTrustSubtitle: "您的安全是我们的首要任务",
    proofOfReserves: "储备金证明",
    proofOfReservesDesc: "100%用户资产可在链上随时验证。",
    coldStorage: "冷存储",
    coldStorageDesc: "大部分资产存储在安全的离线冷钱包中。",
    regularAudits: "定期审计",
    regularAuditsDesc: "第三方安全审计确保最高标准。",
    insuranceFund: "保险基金",
    insuranceFundDesc: "专门基金保护用户免受意外情况。",
    leadershipTeam: "领导团队",
    leadershipSubtitle: "认识推动我们使命的人们",
    globalPresence: "全球布局",
    globalPresenceSubtitle: "为全球用户提供区域支持",
    joinOurTeam: "加入我们的团队",
    joinTeamDesc: "我们一直在寻找对加密货币充满热情的人才。",
    viewOpenPositions: "查看空缺职位",
    teamMembers: "团队成员",
    countries: "国家",
    openRoles: "空缺职位",
    remoteFriendly: "支持远程",
    getInTouch: "联系我们",
    getInTouchSubtitle: "有问题吗？我们随时为您服务",
    emailUs: "发送邮件",
  },
  
  chat: {
    title: "VAROTRADES助手",
    online: "在线",
    welcomeMessage: "您好！👋 我是您的VAROTRADES AI助手。\n\n今天我能为您做什么？",
    placeholder: "输入您的消息...",
    poweredBy: "AI驱动",
    instantSupport: "24/7即时支持",
    newChat: "新对话",
    errorMessage: "抱歉，发生错误。请重试。",
    connectionError: "抱歉，连接错误。请稍后重试。",
    quickQuestion1: "如何开始交易？",
    quickQuestion2: "费用是多少？",
    quickQuestion3: "如何充值？",
    quickQuestion4: "平台安全吗？",
  },
  
  languages: {
    ar: "العربية",
    en: "English",
    es: "Español",
    de: "Deutsch",
    zh: "中文",
    ja: "日本語",
    he: "עברית",
  },
};

export default zh;
